import type { TIrrigationSchedulerStoreState } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { DAYS_BY_DATE_VIEW } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { getSelectedPropertyTimezoneForIrrigationScheduler } from 'App/irrigation-scheduler/utils/store/selectors/getSelectedPropertyTimezoneForIrrigationScheduler'
import moment from 'moment-timezone'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'

export const getDateRange = (fass: TFieldAssetStoreState, isss: TIrrigationSchedulerStoreState) => {
  const timezone = getSelectedPropertyTimezoneForIrrigationScheduler(fass, isss)
  const days = DAYS_BY_DATE_VIEW[isss.dateView]
  const mDateFrom = moment.tz(isss.dateFrom, timezone)
  const mDateTo = moment.tz(isss.dateFrom, timezone).add(days, 'days')

  return {
    mDateFrom,
    mDateTo,
  }
}
